export const theme = (theme) => ({
  ...theme,
  borderRadius: 0,
  colors: {
    ...theme.colors,
    primary25: "#c1c1c1",
    primary: "#658D1B",
    neutral70: "white",
    neutral0: "white",
    dangerLight: "#658D1B",
    danger: "white",
  }
});